import Item from '@/models/Item';
import { LanguageType } from '@/models/LanguageType';
import { contentService } from '@/services/ContentService';
import { ApplicationState } from '@/store';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Loader from '../Loader';
import './style.scss';

interface Props {
    content: Item;
}

const HtmlPlayer: React.FC<Props> = (props: Props) => {
    const FALLBACK_HEIGHT: number = 600;

    const { content } = props;
    const [loading, setLoading] = useState<boolean>(true);

    const { currentContentLanguage } = useSelector((state: ApplicationState) => ({
        currentContentLanguage: state.locale.currentContentLanguage || (state.locale.data._LANGUAGE as LanguageType),
    }));

    const [currentContentPath, setCurrentContentPath] = useState<string>();

    useEffect(() => {
        let internalPath!: string;
        if (currentContentPath && currentContentPath.startsWith('/static')) {
            if (process.env.NODE_ENV === 'development') {
                internalPath = window.location.origin.split(':3000')[0] + currentContentPath;
            }
        }

        const iframePlayer: HTMLIFrameElement = document.getElementById('iframe-player') as HTMLIFrameElement;
        if (iframePlayer && iframePlayer.contentWindow) {
            const path: string = (internalPath || currentContentPath) as string;
            iframePlayer.contentWindow.location.replace(path);
        }
    }, [currentContentPath]);

    const loadNewPathByNewLanguage = useCallback(() => {
        if (currentContentLanguage) {
            setCurrentContentPath(contentService.getContentPathByLanguageType(content, currentContentLanguage));
        }
    }, [content, currentContentLanguage]);

    useEffect(loadNewPathByNewLanguage, [currentContentLanguage]);

    const onIframeLoadHandler = (event: React.SyntheticEvent) => {
        const element: HTMLIFrameElement = event.target as HTMLIFrameElement;

        setTimeout(() => {
            setLoading(false);

            let height: number = 0;

            if (element.contentDocument) {
                height = element.contentDocument.body.offsetHeight;
            }

            element.style.height = `${height || FALLBACK_HEIGHT}px`;
        }, 1000);
    };

    return (
        <div className="html-player-playlist">
            {loading && <Loader />}
            <iframe className={`${loading && 'hide'}`} id="iframe-player" onLoad={onIframeLoadHandler} src="#" />
        </div>
    );
};

export default HtmlPlayer;
